import {
    Card,
    CardBody,
    CardFooter,
    Typography,
    Button,
    Dialog,
    Input,
    Checkbox,
    Tooltip,
    CardHeader,
  } from "@material-tailwind/react";
  import { ethers } from "ethers";
  import abi from "../utils/AuctionRegistry.json";
  import auctionAbi from "../utils/MedicalServiceAuction.json";
  import { useState, useEffect } from "react";
  const TABLE_HEAD = ["Contract Address"];
  
  const TABLE_ROWS = [
    {
      name: "John Michael",
      job: "Manager",
      date: "23/04/18",
      status: "Pending",
    },
    {
      name: "Alexa Liras",
      job: "Developer",
      date: "23/04/18",
      status: "Accepted",
    },
    {
      name: "Laurent Perrier",
      job: "Executive",
      date: "19/09/17",
    },
    {
      name: "Michael Levi",
      job: "Developer",
      date: "24/12/08",
    },
    {
      name: "Richard Gran",
      job: "Manager",
      date: "04/10/21",
    },
  ];
  
  export function PendingBidsTab(props) {
    const contractAddress = "0xBAE1F63B420E8b2725C059374A807c862d613C3d";
    const contractABI = abi.abi;
  
    let auctionContractAddress = "";
    const auctionContractABI = auctionAbi.abi;
  
    const [servicesList, setServicesList] = useState([]);
    const [details, setDetails] = useState([]);
    const [open, setOpen] = useState(false);
  
    const handleOpen = () => setOpen((cur) => !cur);
  
    const [placeBid, setPlaceBid] = useState({
      price: "",
    });
  
    const getAllAuctionDetails = async (e) => {
      try {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const connectedAddress = await signer.getAddress();
        const deployedContract = new ethers.Contract(
          contractAddress,
          contractABI,
          signer
        );
        const servicesPlaced = await deployedContract.getAuctionsForPatient(
          connectedAddress
        );
        //const result = await deployedContract.getMedicalServiceAuctionDetails(servicesPlaced);
        setServicesList(servicesPlaced);
      } catch (error) {
        console.log(error.reason);
      }
    };
  
    const populateTable = async () => {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const connectedAddress = await signer.getAddress();
      const deployedContract = new ethers.Contract(
        contractAddress,
        contractABI,
        signer
      );
      const allDetails = await Promise.all(
        servicesList.map(async (i) => {
          const result = await deployedContract.getMedicalServiceAuctionDetails(
            i
          );
          const auctionContract = new ethers.Contract(
            i,
            auctionContractABI,
            signer
          );
          const bidStatus = await auctionContract.hasPlacedBid(connectedAddress);
          if (bidStatus) {
            // Only return details if bidStatus is false
            return {
              patient: result[0],
              service: result[1],
              biddingEndTime: ethers.BigNumber.from(result[2]).toString(),
              budget: ethers.BigNumber.from(result[3]).toString(),
              location: result[4],
              contractAddress: i,
            };
          }
          return null; // Return null for auctions where bidStatus is true
        })
      );
  
      setDetails(allDetails.filter((detail) => detail !== null)); // Only keep non-null details
    };
  
    const handleChange = (e) => {
      e.preventDefault();
      setPlaceBid({
        ...placeBid,
        [e.target.name]: e.target.value,
      });
    };
  
    const handlePlaceABid = async (contractAddr, event) => {
      event.preventDefault();
      auctionContractAddress = contractAddr;
      try {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const connectedAddress = await signer.getAddress();
        // Log and check the connected address
        console.log("Connected Address", connectedAddress);
        const deployedContract = new ethers.Contract(
          auctionContractAddress,
          auctionContractABI,
          signer
        );
        // Validate that the contract is connected to the correct address
        // console.log("Contract Signer Address", await deployedContract.signer.getAddress());
        const answer = await deployedContract.placeBid({ value: placeBid.price });
        // console.log("Auction Response", answer.value);
        // Wait for the transaction to be mined and get the receipt
        // const receipt = await answer.wait();
        // console.log("Transaction Receipt", receipt);
      } catch (error) {
        console.log(error.reason);
      }
    };
  
    useEffect(() => {
      getAllAuctionDetails();
    }, []); // Empty dependency array so it runs once after the component mounts
  
    useEffect(() => {
      if (servicesList.length > 0) {
        populateTable();
      }
    }, [servicesList]); // Runs every time servicesList changes
  
    return (
      <div className="flex flex-wrap">
        {details.map((detail, index) => (
          <div key={index} className="w-full sm:w-1/2 md:w-1/2 lg:w-1/2 p-2">
            <Card className="mx-auto mt-6 w-full sm:w-3/4">
              <CardBody>
                <Typography variant="h6" color="blue-gray" className="mb-2">
                  Service: {detail.service}
                </Typography>
                <Tooltip
                  content={<div>{detail.contractAddress}</div>}
                  interactive={true}
                  placement="top"
                  offset={5}
                >
                  <Typography
                    variant="h6"
                    color="blue-gray"
                    className="mb-2 truncate w-11/12 hover:bg-gray-200"
                  >
                    {detail.contractAddress}
                  </Typography>
                  
                </Tooltip>
                <Typography>
                  <p>
                    <strong>Bidding End Time:</strong> {detail.biddingEndTime}
                  </p>
                  <p>
                    <strong>Budget:</strong> ${detail.budget}
                  </p>
                  <p>
                    <strong>Location:</strong> {detail.location}
                  </p>
                </Typography>
              </CardBody>
            </Card>
  
            <Dialog
              size="xs"
              open={open}
              handler={handleOpen}
              className="bg-transparent shadow-none"
            >
              <Card className="mx-auto w-full max-w-[24rem]">
                <CardHeader
                  variant="gradient"
                  color="blue"
                  className="mb-4 grid h-28 place-items-center"
                >
                  <Typography variant="h3" color="white">
                    Bid
                  </Typography>
                </CardHeader>
                <CardBody className="flex flex-col gap-4">
                  <Input
                    label="Price"
                    name="price"
                    size="lg"
                    value={placeBid.price}
                    onChange={handleChange}
                    autocomplete="off"
                  />
                </CardBody>
                <CardFooter className="pt-0">
                  <Button
                    variant="gradient"
                    onClick={(event) =>
                      handlePlaceABid(detail.contractAddress, event)
                    }
                    fullWidth
                  >
                    Place Bid
                  </Button>
                </CardFooter>
              </Card>
            </Dialog>
          </div>
        ))}
      </div>
    );
  }
  